let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("iAspJ"), load("gM13h")]).then(() => parcelRequire('1RPPn'));